﻿{
  "community": {
    "name": "Community",
    "titles": {
      "1": "Community online",
      "2": "Trova materiale",
      "3": "Condividi le tue creazioni"
    },
    "body": {
      "1": "Un posto fantastico in cui immergersi e scoprire tutto ciò che Boardmaker ha da offrire",
      "2": "Scopri le creazioni e le condivisioni degli altri. È come una finestra nella mondo magico di Boardmaker!",
      "3": "Tramite il software Boardmaker preferito, carica e condividi le tue creazioni con la community"
    }
  },
  "personal": {
    "name": "Privato",
    "header": "Include tutte le funzioni della Community, in più:",
    "titles": {
      "1": "Crea, modifica, riproduci e stampa",
      "2": "Software Boardmaker"
    },
    "body": {
      "1": "Per un genitore o un assistente con un bambino che desidera creare, modificare, riprodurre o stampare attività",
      "2": "Gli account sono dotati di una licenza Boardmaker 7 installabile su 2 computer Windows"
    }
  },
  "professional": {
    "name": "Professionista",
    "header": "Include tutte le funzioni della sottoscrizione per privati, in più:",
    "titles": {
      "1": "Gestione Studenti",
      "2": "Impostazioni personalizzate"
    },
    "body": {
      "1": "Per gli istruttori con 1-50 studenti che desiderano assegnare attività e monitorare i dati degli studenti",
      "2": "Impostazioni di accesso personalizzate per i singoli utenti"
    }
  },
  "organization": {
    "name": "Azienda",
    "header": "Include tutte le funzioni della sottoscrizione per professionisti, in più:",
    "titles": {
      "1": "Supporto del team multidisciplinare"
    },
    "body": {
      "1": "Prezzi a volume, l'azienda controlla le informazioni e più persone possono eseguire le assegnazioni agli stessi studenti"
    }
  }
}
